import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";
import axios from "axios";

import usFlag from "../../assets/images/flags/us.jpg";
import germany from "../../assets/images/flags/germany.jpg";

const LanguageDropdown = (props) => {
  const { t } = useTranslation();
  let link = localStorage.getItem("link");

  const [menu, setMenu] = useState(false);
  const [flag, setFlag] = useState(usFlag);
  const [lng, setLng] = useState(localStorage.getItem("i18nextLng"));

  useEffect(() => {
    if (lng === "de") {
      setFlag(germany);
    } else if (lng === "en") {
      setFlag(usFlag);
    }
  }, [lng]);

  function changeLanguageAction(lng) {
    i18n.changeLanguage(lng);

    if (lng === "de") {
      setFlag(germany);
      setLng("German");
    } else if (lng === "en") {
      setFlag(usFlag);
      setLng("English");
    }

    document
      .getElementsByTagName("html")[0]
      .setAttribute("lang", localStorage.getItem("i18nextLng"));

    const data = {
      languageCode: lng,
    };

    axios
      .post(link + "/api/User/update-language", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {})
      .catch((error) => {});
  }

  return (
    <Dropdown
      isOpen={menu}
      toggle={() => setMenu(!menu)}
      className="d-inline-block"
    >
      <DropdownToggle className="btn header-item waves-effect" tag="button">
        <img src={flag} height="16" className="mr-1" />
      </DropdownToggle>
      <DropdownMenu className="language-switch dropdown-menu" right>
        <DropdownItem
          className="dropdown-item"
          onClick={() => changeLanguageAction("de")}
        >
          <img src={germany} className="mr-1" height="12" />
          <span>{t("allgemein.sprachen.de")}</span>
        </DropdownItem>
        <DropdownItem
          className="dropdown-item"
          onClick={() => changeLanguageAction("en")}
        >
          <img src={usFlag} className="mr-1" height="12" />
          <span>{t("allgemein.sprachen.en")}</span>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default LanguageDropdown;
